import React from 'react';
import { IndexRoute, IndexRedirect, Route } from 'react-router';
import Loadable from 'react-loadable';
// import BrowserHistory from 'react-router/lib/BrowserHistory';
// import { reduxRouteComponent } from 'redux-react-router';
// import observableFromStore from '../utils/observableFromStore';
// import * as observables from '../observables';
import App from './App';
import * as UserDashboard from './UserProfile/User';

import ConfirmEmail from './public/ConfirmEmail';
import Login from './public/Login';
import Pricing from './public/Pricing/';
import Register from './public/Register';
import ResetPassword from './public/ResetPassword';
import ForgotPassword from './public/ForgotPassword';
import FourOhFour from './public/404';

import Organizations from './Organizations';
import Accounts from './Accounts';
import * as Organization from './Organization';
import * as Account from './Account';
import * as Admin from './Admin/';
import Projects from './Projects';
import Notifications from './Notifications';

import OrgAdmin from './Admin/Organization';
import OrgAdminBilling from './Admin/OrganizationBilling';
import OrgAdminPlan from './Admin/OrganizationPlan';
import OrgSubscription from './Admin/OrganizationSubscription';
import CreateSubscription from './Admin/CreateSubscription';
import AdminPlans from './Admin/Plans';

import Element from '../components/Element';
// import Relationship from '../components/Relationship';

import ProjectDefaultTab from './Project/TaskHome';
import TaskDoctor from './Project/TaskDoctor';

import Baselines from './ProjectSettings/Baselines';
import DailyTasksComplete from './ProjectSettings/DailyTasksComplete';
import DailyTasksCompleteList from './ProjectSettings/DailyTasksCompleteList';
import ElementsByTypeTab from './ProjectSettings/ElementsByType';
import ProjectContainer from './Project/ProjectContainer';
import ElementType from './ProjectSettings/ElementType';
import ElementTypes from './ProjectSettings/ElementTypes';
import ImportDefaultTab from './ProjectSettings/Imports';
import ProjectExport from './ProjectSettings/Exports';
import ProjectUsersDefaultTab from './ProjectSettings/ProjectUsers';
import RelationshipType from './ProjectSettings/RelationshipType';
import RelationshipTypes from './ProjectSettings/RelationshipTypes';
import Settings from './ProjectSettings/Settings';
import WBS from './Project/WBS';

// import ElementDefaultTab from '../components/defaults/Element';
import CurrentUserContext from '../contexts/CurrentUser';

function Loading(props) {
  if (props.error) {
    return <div>Error!</div>;
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
}

const AsyncSignUp = Loadable({
  loader: () => import('./public/SignUp/'),
  loading: Loading,
  delay: 300,
});

const AsyncProjectSettings2 = Loadable({
  loader: () => import('./ProjectSettings/ProjectSettings'),
  loading: Loading,
  delay: 300,
});

const AsyncGantt = Loadable({
  loader: () => import('./Project/gantt'),
  loading: Loading,
  delay: 300,
});

const AsyncView = Loadable({
  loader: () => import('./Project/View'),
  loading: Loading,
  delay: 300,
});

const AsyncDsm = Loadable({
  loader: () => import('./Project/taskDsm'),
  loading: Loading,
  delay: 300,
});

const AsyncList = Loadable({
  loader: () => import('./Project/List'),
  loading: Loading,
  delay: 300,
});

const AsyncProject = Loadable({
  loader: () => import('./Project'),
  loading: Loading,
});

const TaskHomeContainer = Loadable({
  loader: () => import('./Project/TaskHome/'),
  loading: Loading,
});

export default (
  <Route path="/" component={App}>
    <Route
      path="/admin"
      component={props => (
        <CurrentUserContext.Consumer>
          {ctx => <Admin.AdminDashboard {...props} {...ctx} />}
        </CurrentUserContext.Consumer>
      )}
    >
      <Route path="plans" component={AdminPlans} />
      {/* <Route path="organizations" component={Admin.Organizations} /> */}
      <Route
        path="organizations"
        component={props => (
          <CurrentUserContext.Consumer>
            {ctx => <Admin.Organizations {...props} {...ctx} />}
          </CurrentUserContext.Consumer>
        )}
      />
      <Route path="organization/:organizationId">
        <IndexRoute component={OrgAdmin} />
        <Route path="subscriptions/create" component={CreateSubscription} />
        <Route
          path="subscription/:subscriptionId"
          component={OrgSubscription}
        />
        <Route path="billing" component={OrgAdminBilling} />
        <Route path="plan" component={OrgAdminPlan} />
      </Route>
    </Route>
    <Route path="/signup" component={AsyncSignUp} type={'construction'} />
    <Route path="/freetrial/signup" component={AsyncSignUp} type={'generic'} />
    <Route path="/pricing" component={Pricing} />
    <IndexRedirect to="/login" />
    <Route path="/notifications" component={Notifications} />
    <Route path="/login" component={Login} />
    <Route path="/confirm/email/:hash" component={ConfirmEmail} />
    <Route path="/register(/:hash)" component={Register} />
    <Route path="/forgot/password" component={ForgotPassword} />
    <Route path="/forgot/password/:hash" component={ResetPassword} />
    <Route path="/accounts" component={Accounts} />
    <Route path="/projects" component={Projects} />
    <Route path="/organizations" component={Organizations} />
    <Route
      path="/organizations/:organizationId"
      component={Organization.OrganizationDashboard}
    >
      <IndexRedirect to="accounts" />
      <Route path="dashboard" component={Organization.MainDashboard} />
      <Route path="users" component={Organization.Users} />
      <Route path="accounts" component={Organization.Accounts} />
      <Route path="billing" component={Organization.Billing} />
      <Route path="subscriptions" component={Organization.Subscriptions} />
    </Route>
    <Route path="/accounts/:accountId" component={Account.AccountDashboard}>
      <IndexRedirect to="projects" />
      <Route path="dashboard" component={Account.MainDashboard} />
      <Route path="users" component={Account.Users} />
      <Route path="projects" component={Account.Projects} />
    </Route>
    {/*<Route path="/accounts" component={Accounts} />*/}
    <Route path="/user" component={UserDashboard.UserDashboard}>
      <IndexRedirect to="profile" />
      <Route path="profile" component={UserDashboard.UserProfile} />
      <Route path="settings" component={UserDashboard.UserSettings} />
      <Route path="email" component={UserDashboard.UserEmail} />
      <Route path="password" component={UserDashboard.UserPassword} />
    </Route>
    {/*<Route path="/accounts/:accountId" component={Dashboard} />*/}
    <Route path="project/:projectId" component={AsyncProject}>
      <Route path="issues" component={TaskHomeContainer} product={'issues'} />
      <Route path="planner" component={TaskHomeContainer} product={'planner'} />
      <Route path="gantt" component={AsyncGantt} />
      <Route path="dsm" component={AsyncDsm} />
      <Route path="wbs" component={WBS} />
      <Route path="list" component={AsyncList} />
      <Route path="element/:elementId" component={Element} />
      {/* <Route path="elements" component={ElementDefaultTab} /> */}
      <Route
        path="element-type/:elementTypeId/elements"
        component={ElementsByTypeTab}
      />
      <Route path="view/:viewId" component={AsyncView} />
      {/* <Route path="relationship/:relationshipId" component={Relationship} /> */}
      <Route path="default" component={ProjectDefaultTab} />
      <Route path="task-doctor" component={TaskDoctor} />
      {/*<Route path="report/:reportId" component={Report} />*/}
      <Route path="settings" component={Settings}>
        <IndexRoute component={AsyncProjectSettings2} />
        <Route path="reports/daily" component={DailyTasksCompleteList} />
        <Route path="reports/daily/:reportId" component={DailyTasksComplete} />
        <Route path="project" component={AsyncProjectSettings2} />
        <Route path="baselines" component={Baselines} />
        <Route path="relationship-types" component={RelationshipTypes} />
        <Route path="element-types" component={ElementTypes} />
        <Route path="users" component={ProjectUsersDefaultTab} />
        <Route path="import" component={ImportDefaultTab} />
        <Route
          path="element-type/:elementTypeId/elements"
          component={ElementsByTypeTab}
        />
        <Route path="element-type/:elementTypeId" component={ElementType} />
        <Route
          path="relationship-type/:relationshipTypeId"
          component={RelationshipType}
        />
        <Route path="export" component={ProjectExport} />
      </Route>
    </Route>
    <Route path="*" component={FourOhFour} />
  </Route>
);

// function asyncComponent(importComponent) {
//   class AsyncComponent extends React.Component {
//     constructor(props) {
//       super(props);
//
//       this.state = {
//         component: null,
//       };
//     }
//
//     async componentDidMount() {
//       const { default: component } = await importComponent();
//
//       this.setState({
//         component: component,
//       });
//     }
//
//     render() {
//       const C = this.state.component;
//
//       return C ? <C {...this.props} /> : null;
//     }
//   }
//
//   return AsyncComponent;
// }



// WEBPACK FOOTER //
// ./src/views/routes.js